/* Great Northern — Fragrance Consultation (finder). Scoped to [data-ff]. No dependencies. */
(function () {
  'use strict';

  var FAMS = ['woody', 'smoky', 'gourmand', 'floral', 'fruity', 'fresh', 'green', 'spicy', 'musky'];

  /* Keyword vocabulary read from each product's own notes (title) — new products classify themselves. */
  var KW = {
    woody: ['cedar', 'fir', 'pine', 'sandalwood', 'bois', 'wood', 'bark', 'conifer', 'sycamore', 'oak', 'juniper', 'larch', 'pitch', 'cypress', 'vetiver', 'hemlock', 'planks', 'forest', 'sentinel', 'cascadia'],
    smoky: ['smoke', 'smoky', 'smokey', 'smolder', 'campfire', 'bonfire', 'firelight', 'ember', 'tobacco', 'leather', 'labdanum', 'cigarette', 'fire', 'cognac', 'resinous'],
    gourmand: ['vanilla', 'tonka', 'caramel', 'chocolate', 'coffee', 'roast', 'almond', 'rum', 'bourbon', 'brandy', 'cognac', 'milk', 'shortbread', 'popcorn', 'honey', 'brie', 'baguette', 'bread', 'beer', 'sugar', 'butter', 'cider', 'carnival', 'syrup'],
    floral: ['rose', 'jasmine', 'neroli', 'orchid', 'freesia', 'geranium', 'oleander', 'lavender', 'chrysanthemum', 'floral', 'blooms', 'blossom', 'iris', 'violet'],
    fruity: ['cherry', 'berr', 'pomegranate', 'apple', 'fig', 'peach', 'plum', 'lychee', 'orange', 'lemon', 'stone fruit', 'cider', 'jam'],
    fresh: ['sea air', 'coastal', 'rain', 'mineral', 'mint', 'beach', 'surf', 'suntan', 'white tea', 'salty', 'fog', 'citrus', 'zest', 'air', 'springs', 'glass', 'clean'],
    green: ['moss', 'tomato', 'grass', 'herbal', 'sage', 'monstera', 'agave', 'hay', 'chanterelle', 'forest floor', 'leaves', 'hops', 'green', 'fern', 'wild carrot', 'sweetgrass', 'rainforest', 'greenhouse'],
    spicy: ['amber', 'spice', 'clove', 'cinnamon', 'saffron', 'pepper', 'cardamom', 'resin', 'ambergris', 'mulled', 'incense'],
    musky: ['musk', 'cashmere', 'skin', 'powder', 'patchouli', 'velvet', 'satin']
  };

  /* Store collections that already describe a scent family. */
  var COLL = {
    'woody-fragrance-collection': 'woody', 'woody-perfume': 'woody', 'floral': 'floral', 'floral-perfume': 'floral',
    'fresh': 'fresh', 'fresh-coastal-perfume': 'fresh', 'earthy': 'green', 'fruity': 'fruity', 'gourmand-1': 'gourmand',
    'gourmand-perfume': 'gourmand', 'spicy': 'spicy', 'spicy-perfume': 'spicy', 'amber-resin-perfume': 'spicy',
    'musky-skin-scent-perfume': 'musky'
  };
  var MYSTERY_COLL = ['peaks', 'doppelland', 'doppelland-1', 'doppelland-candles', 'strange-wonderful', 'halloween-shop', 'the-dreamer'];

  var FAM_PHRASE = {
    woody: 'the dry, resinous structure of Northwest woods',
    smoky: 'a thread of smoke and worn leather',
    gourmand: 'a warm, almost edible sweetness',
    floral: 'a softly lit floral heart',
    fruity: 'dark, ripe fruit',
    fresh: 'cool, mineral air',
    green: 'moss, leaf and damp forest floor',
    spicy: 'amber and a quiet warmth of spice',
    musky: 'a soft musk that settles close to the skin'
  };
  var FAM_LABEL = { woody: 'Woods', smoky: 'Smoke & Leather', gourmand: 'Warm & Sweet', floral: 'Floral', fruity: 'Fruit', fresh: 'Fresh & Mineral', green: 'Green & Earth', spicy: 'Amber & Spice', musky: 'Musk & Skin' };

  /* ---------------- Question sets ---------------- */
  var AVOID = {
    id: 'avoid', multi: 9, optional: true,
    q: 'Is there anything you would rather not wear?', qHome: 'Is there anything you would rather not live with?',
    sub: 'Choose any that apply, or continue if you are open to everything.',
    opts: [
      { k: 'gourmand', t: 'Sweetness', d: 'Vanilla, caramel, sugared notes', avoid: 'gourmand' },
      { k: 'floral', t: 'Pronounced florals', d: 'Rose, jasmine, blossom', avoid: 'floral' },
      { k: 'smoky', t: 'Smoke', d: 'Woodsmoke, tobacco, leather', avoid: 'smoky' },
      { k: 'fruity', t: 'Fruit', d: 'Cherry, berry, orchard notes', avoid: 'fruity' }
    ]
  };


  /* Quote-led mood step. Each line quietly maps to the collections made in its spirit (Twin Peaks, Forks, coast, rainforest, Mount Hood, Halloween). */
  var INSPIRE = {
    id: 'insp', q: 'Which line would you begin with today?', sub: 'Choose the one that sounds like you right now.', wide: 1,
    opts: [
      { k: 'peaks', t: '', d: 'A mountain lodge, black coffee, something hidden', quote: 'The owls are not what they seem.',
        claim: ['peaks', 'doppelland', 'doppelland-1', 'doppelland-candles', 'strange-wonderful', 'the-dreamer', 'cooper'], w: { woody: .3, smoky: .2 }, mystery: .6, label: 'Twin Peaks' },
      { k: 'forks', t: '', d: 'Rain, moss and a cold, beautiful forest', quote: 'And so the lion fell in love with the lamb.',
        claim: ['forks-collection', 'forks', 'la-push-la-surf'], colls: ['new-moon', 'eclipse', 'flightless-bird'], w: { green: .3, woody: .2, fresh: .15 }, label: 'Forks' },
      { k: 'cannon', t: '', d: 'Sea stacks, salt air, coastal pine', quote: 'Never say die.',
        colls: ['never-say-die', 'coast-range', 'coastal-reset', 'la-push-la-surf'], kw: ['sea air', 'coastal', 'surf', 'beach'], w: { fresh: .4, woody: .1 }, label: 'Cannon Beach' },
      { k: 'olympic', t: '', d: 'Rainforest, ancient cedar, wolf country', quote: 'Moss on everything, and the sound of rain.',
        colls: ['loup-sauvage-wild-wolf-forest-air-ancient-cedars-soft-amber', 'loree-du-bois', 'out-of-the-woods'], claim: ['the-hoh-rainforest'], kw: ['rainforest', 'hoh', 'ancient cedar'], w: { green: .4, woody: .3 }, label: 'the Olympic rainforest' },
      { k: 'hood', t: '', d: 'High country, fir and woodsmoke', quote: 'Snow on the ridge, a fire in the lodge.',
        colls: ['larch-mtn', 'cascadia', 'woodland-cottage', 'willow'], kw: ['larch', 'conifer'], w: { woody: .4, smoky: .2 }, label: 'Mount Hood' },
      { k: 'helens', t: '', d: 'A river town in October, bonfires and fallen leaves', quote: 'Being normal is vastly overrated.',
        claimKw: ['halloweentown'], colls: ['halloween-shop'], kw: ['bonfire', 'fall leaves'], w: { smoky: .2, gourmand: .2, spicy: .2 }, label: 'St. Helens in October', only: 'home' },
      { k: 'witch', t: '', d: 'Night-blooming flowers, vanilla and a little mischief', quote: 'There\u2019s a little witch in all of us.',
        colls: ['signature', 'francesca', 'interlude', 'forever', 'rosalie', 'burlap-satin-extrait-de-parfum'], kw: ['jasmine', 'rose', 'vanilla', 'musk', 'tonka', 'freesia'], w: { floral: .2, gourmand: .2 }, label: 'the line you chose', only: 'wear' },
      { k: 'none', t: 'None of these today', d: 'Let the notes lead the way', label: '', skip: 1 }
    ]
  };

  var PATHS = {
    wear: {
      label: 'To Wear',
      questions: [
        { id: 'fam', multi: 2, q: 'Which accords are you drawn to?', sub: 'Choose up to two. Trust your first instinct.',
          opts: [
            { k: 'woods', t: 'Woods & Resins', d: 'Cedar, fir, sandalwood, pitch', w: { woody: 1, spicy: .15 } },
            { k: 'smoke', t: 'Smoke & Leather', d: 'Woodsmoke, tobacco, labdanum', w: { smoky: 1, woody: .3 } },
            { k: 'warm', t: 'Warm & Sweet', d: 'Vanilla, tonka, bourbon, cocoa', w: { gourmand: 1, musky: .15 } },
            { k: 'floral', t: 'Florals', d: 'Rose, jasmine, neroli, freesia', w: { floral: 1 } },
            { k: 'fruit', t: 'Ripe Fruit', d: 'Cherry, fig, berries, apple', w: { fruity: 1, gourmand: .15 } },
            { k: 'fresh', t: 'Fresh & Mineral', d: 'Sea air, mint, rain, white tea', w: { fresh: 1, green: .3 } },
            { k: 'musk', t: 'Musk & Skin', d: 'Clean musk, cashmere, soft milk', w: { musky: 1, gourmand: .2 } },
            { k: 'spice', t: 'Amber & Spice', d: 'Saffron, pepper, clove, amber', w: { spicy: 1, woody: .2 } }
          ] },
        { id: 'mood', q: 'How would you like to feel wearing it?', sub: 'The impression you leave matters as much as the notes.',
          opts: [
            { k: 'composed', t: 'Composed', d: 'Clean, quiet, assured', w: { fresh: .6, musky: .6, woody: .2 }, phrase: 'something composed and quietly assured' },
            { k: 'warm', t: 'Enveloped', d: 'Warm, soft, comforting', w: { gourmand: .6, spicy: .35, musky: .35 }, phrase: 'warmth you can wrap yourself in' },
            { k: 'dark', t: 'Mysterious', d: 'Dark, layered, a little unknowable', w: { smoky: .6, woody: .5, spicy: .2 }, mystery: 1, phrase: 'a darker, more layered presence' },
            { k: 'romantic', t: 'Romantic', d: 'Tender, glowing, close', w: { floral: .6, fruity: .3, gourmand: .2, musky: .2 }, phrase: 'something tender and romantic' },
            { k: 'wild', t: 'Untamed', d: 'Outdoors, weather, open air', w: { green: .6, woody: .6, fresh: .3 }, phrase: 'the feeling of being outdoors in weather' }
          ] },
        INSPIRE,
        { id: 'when', q: 'When will you wear it most?', sub: '',
          opts: [
            { k: 'daily', t: 'Every day', d: 'A signature for ordinary hours', season: 0, int: -.15, phrase: 'every day' },
            { k: 'evening', t: 'Evenings', d: 'Dinners, occasions, after dark', season: 0, int: .25, mystery: .4, phrase: 'in the evening' },
            { k: 'cold', t: 'The colder months', d: 'Wool coats, early dark', season: -1, phrase: 'through the colder months' },
            { k: 'warm', t: 'The warmer months', d: 'Long light, bare skin', season: 1, phrase: 'through the warmer months' }
          ] },
        { id: 'proj', q: 'How present should it be?', sub: 'This guides the concentration we recommend.',
          opts: [
            { k: 'close', t: 'Close to the skin', d: 'Discovered only when someone leans in', int: -.35, conc: 'edt', phrase: 'worn close' },
            { k: 'trail', t: 'A soft trail', d: 'Noticed as you pass', int: 0, conc: 'extrait', phrase: 'with a soft trail' },
            { k: 'room', t: 'Remembered', d: 'Felt in the room after you leave', int: .4, conc: 'extrait', phrase: 'with real presence' }
          ] },
        AVOID,
        { id: 'fmt', q: 'How would you like to begin?', sub: 'Every fragrance is poured to order in Portland.',
          opts: [
            { k: 'full', t: 'The full bottle', d: '50 ml · our recommendation' },
            { k: 'travel', t: 'A travel bottle', d: '15 ml or 10 ml' },
            { k: 'body', t: 'As a body ritual', d: 'Whipped butter, lotion or wash' },
            { k: 'vial', t: 'A discovery vial', d: '2 ml, to try on skin first' }
          ] }
      ]
    },
    home: {
      label: 'For the Home',
      questions: [
        { id: 'room', q: 'Which room is this for?', sub: 'Every room asks for something different.',
          opts: [
            { k: 'living', t: 'The living room', d: 'Gathering, conversation, firelight', w: { woody: .5, smoky: .35, spicy: .3, gourmand: .2 }, phrase: 'the living room', big: 1 },
            { k: 'bed', t: 'The bedroom', d: 'Rest, linen, late evenings', w: { musky: .5, floral: .4, gourmand: .2, fresh: .2 }, phrase: 'the bedroom' },
            { k: 'kitchen', t: 'Kitchen & dining', d: 'Warmth, appetite, company', w: { gourmand: .5, fruity: .4, green: .3, fresh: .2 }, phrase: 'the kitchen and dining room' },
            { k: 'bath', t: 'The bath', d: 'Steam, stone, a clean slate', w: { fresh: .6, green: .4, floral: .2 }, phrase: 'the bath' },
            { k: 'study', t: 'A study or office', d: 'Focus, books, quiet hours', w: { woody: .55, smoky: .3, green: .25 }, phrase: 'a study' },
            { k: 'entry', t: 'Entry & hall', d: 'The first impression of a home', w: { woody: .4, fresh: .4, spicy: .2 }, phrase: 'the entry' }
          ] },
        { id: 'fam', multi: 2, q: 'What atmosphere do you want to come home to?', sub: 'Choose up to two.',
          opts: [
            { k: 'forest', t: 'Deep forest', d: 'Fir, cedar, moss after rain', w: { woody: 1, green: .5 } },
            { k: 'fire', t: 'Fireside', d: 'Woodsmoke, leather, embers', w: { smoky: 1, woody: .4 } },
            { k: 'coast', t: 'Coast & weather', d: 'Sea air, rain, driftwood', w: { fresh: 1, green: .3 } },
            { k: 'garden', t: 'Garden & greenhouse', d: 'Tomato leaf, green stems, glass', w: { green: 1, floral: .35, fresh: .2 } },
            { k: 'kitchen', t: 'A warm kitchen', d: 'Vanilla, baking, bourbon', w: { gourmand: 1, spicy: .25 } },
            { k: 'orchard', t: 'The orchard', d: 'Fig, apple, dark berries', w: { fruity: 1, gourmand: .2 } },
            { k: 'flowers', t: 'Fresh-cut flowers', d: 'Jasmine, neroli, rose', w: { floral: 1 } },
            { k: 'amber', t: 'Amber & spice', d: 'Saffron, clove, resin', w: { spicy: 1, woody: .2 } }
          ] },
        INSPIRE,
        { id: 'when', q: 'When will it burn most?', sub: '',
          opts: [
            { k: 'cold', t: 'Autumn & winter', d: 'Early dark, heavy blankets', season: -1, phrase: 'through the darker months' },
            { k: 'warm', t: 'Spring & summer', d: 'Windows open, long light', season: 1, phrase: 'through the lighter months' },
            { k: 'year', t: 'All year', d: 'A house scent that stays', season: 0, phrase: 'all year' }
          ] },
        { id: 'proj', q: 'How should it fill the space?', sub: 'This guides the size and format we recommend.',
          opts: [
            { k: 'quiet', t: 'A quiet backdrop', d: 'Noticed only when you arrive', int: -.35, phrase: 'kept as a quiet backdrop' },
            { k: 'balanced', t: 'Balanced', d: 'Present, never overwhelming', int: 0, phrase: 'present but never overwhelming' },
            { k: 'full', t: 'Room-filling', d: 'Open-plan rooms, high ceilings', int: .4, big: 1, phrase: 'generous enough to fill the room' }
          ] },
        AVOID,
        { id: 'fmt', q: 'Which form suits your home?', sub: 'Most of our scents are poured in every format.',
          opts: [
            { k: 'candle', t: 'Wood-wick candle', d: 'Coconut wax, a soft crackle' },
            { k: 'melts', t: 'Luxe wax melts', d: 'Flameless, for a warmer' },
            { k: 'spray', t: 'Room + pillow spray', d: 'Instant, for linens and air' },
            { k: 'car', t: 'Car diffuser', d: 'Carry it with you' }
          ] }
      ]
    }
  };

  /* ---------------- Utilities ---------------- */
  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function money(cents) { var d = cents / 100; return '$' + (d % 1 === 0 ? d.toFixed(0) : d.toFixed(2)); }
  function roman(n) { return ['', 'I', 'II', 'III', 'IV', 'V', 'VI', 'VII', 'VIII'][n] || n; }
  function baseName(p) {
    return (p.n || '').toLowerCase()
      .replace(/coconut wax wood wick|room perfume|room \+ body mist|luxe wax melts|wax melts|extrait de parfum|perfume|candle|halloween/g, '')
      .replace(/[^a-zà-ÿ' ]/g, ' ').replace(/\s+/g, ' ').trim();
  }

  function cleanName(n) {
    var s = String(n || '');
    for (var i = 0; i < 3; i++) s = s.replace(/\s*(halloween|extrait de parfum|perfume|candle|room perfume|luxe wax melts|wax melts)\s*$/i, '');
    return s.replace(/\s{2,}/g, ' ').trim();
  }
  function cleanNotes(s) {
    return String(s || '').replace(/\b(candle|perfume)\b/ig, ' ').replace(/\s+/g, ' ').replace(/(\s·)+\s*$/, '').replace(/^\s*·\s*/, '').trim();
  }
  function softCase(s) {
    return String(s).split(' ').map(function (w) { return ((w.length > 1 && w === w.toUpperCase() && /[A-Z]/.test(w)) || /^(Douglas|Mission|Brazilian|Gala|Salish|Portland|Oregon)$/.test(w)) ? w : w.toLowerCase(); }).join(' ');
  }
  function profile(p) {
    var text = (' ' + p.n + ' ' + p.notes + ' ').toLowerCase();
    var f = {}; FAMS.forEach(function (k) { f[k] = 0; });
    FAMS.forEach(function (k) { KW[k].forEach(function (w) { if (text.indexOf(w) > -1) f[k] += 1; }); });
    (p.c || []).forEach(function (h) { if (COLL[h]) f[COLL[h]] += .6; });
    var max = 0; FAMS.forEach(function (k) { if (f[k] > max) max = f[k]; });
    if (max > 0) FAMS.forEach(function (k) { f[k] = f[k] / max; });
    var myst = (p.c || []).some(function (h) { return MYSTERY_COLL.indexOf(h) > -1; }) ? 1 : 0;
    var intensity = Math.max(0, Math.min(1, .45 + f.smoky * .3 + f.gourmand * .15 + f.spicy * .2 + f.woody * .05 - f.fresh * .3 - f.floral * .05 - f.green * .1));
    var cold = f.smoky + f.gourmand + f.spicy + f.woody * .5, warm = f.fresh + f.floral + f.fruity + f.green * .5;
    var season = (warm - cold) / Math.max(1, warm + cold); /* -1 cold … +1 warm */
    var best = (p.c || []).indexOf('best-sellers') > -1 || (p.c || []).indexOf('customer-favorites') > -1;
    return { f: f, myst: myst, intensity: intensity, season: season, best: best };
  }

  function userVector(path, ans) {
    var u = {}; FAMS.forEach(function (k) { u[k] = 0; });
    var meta = { season: 0, int: 0, myst: 0, avoid: [], insp: null };
    PATHS[path].questions.forEach(function (q) {
      var picked = ans[q.id] || [];
      picked.forEach(function (key) {
        var o = q.opts.filter(function (x) { return x.k === key; })[0]; if (!o) return;
        var mult = q.id === 'fam' ? 1.6 : 1;
        if (o.w) Object.keys(o.w).forEach(function (k) { u[k] += o.w[k] * mult; });
        if (o.season) meta.season += o.season;
        if (o.int) meta.int += o.int;
        if (o.mystery) meta.myst += o.mystery;
        if (o.avoid) meta.avoid.push(o.avoid);
        if (q.id === 'insp' && o.label) meta.insp = o;
      });
    });
    meta.avoid.forEach(function (k) { u[k] = 0; });
    return { u: u, meta: meta };
  }

  /* 2 = made for this place (its own collection), 1 = shares its air, 0 = no tie */
  function inspired(p, o) {
    var c = p.c || [], txt = (p.n + ' ' + p.notes).toLowerCase();
    if ((o.claim || []).some(function (h) { return c.indexOf(h) > -1; }) || (o.claimKw || []).some(function (w) { return txt.indexOf(w) > -1; })) return 2;
    if ((o.colls || []).some(function (h) { return c.indexOf(h) > -1; }) || (o.kw || []).some(function (w) { return txt.indexOf(w) > -1; })) return 1;
    return 0;
  }
  function score(prod, uv) {
    var pr = prod._p, u = uv.u, m = uv.meta, dot = 0, nu = 0, np = 0;
    FAMS.forEach(function (k) { dot += u[k] * pr.f[k]; nu += u[k] * u[k]; np += pr.f[k] * pr.f[k]; });
    var s = (nu && np) ? dot / Math.sqrt(nu * np) : 0;
    s += m.season ? -Math.abs(m.season - pr.season) * .12 + .06 : 0;
    s += -Math.abs((.5 + m.int) - pr.intensity) * .12;
    s += m.myst ? pr.myst * .08 * m.myst : 0;
    m.avoid.forEach(function (k) { if (pr.f[k] >= .45) s -= .6; else if (pr.f[k] > 0) s -= .15; });
    if (m.insp) { var ti = inspired(prod, m.insp); s += ti === 2 ? .3 : (ti === 1 ? .1 : 0); }
    if (pr.best) s += .03;
    if (prod.boost) s += .05;
    return s;
  }

  /* Choose the exact variant to recommend from the product's real variants. */
  function pickVariant(p, path, ans) {
    var vs = (p.v || []).filter(function (v) { return v[3]; });
    if (!vs.length) return null;
    function find(tests) {
      for (var i = 0; i < tests.length; i++) {
        var t = tests[i];
        for (var j = 0; j < vs.length; j++) { var vt = vs[j][1].toLowerCase(); if (t.every(function (w) { return vt.indexOf(w) > -1; })) return vs[j]; }
      }
      return null;
    }
    var fmt = (ans.fmt || [])[0];
    if (path === 'wear') {
      var conc = ((ans.proj || [])[0] === 'close') ? ['eau de toilette', 'extrait'] : ['extrait', 'eau de toilette'];
      if (fmt === 'vial') return find([['2ml'], ['2 ml'], ['vial']]) || find([['15 ml']]);
      if (fmt === 'body') return find([['body butter'], ['lotion'], ['wash']]) || find([['50 ml', conc[0]]]);
      if (fmt === 'travel') return find([['15 ml', conc[0]], ['15 ml', conc[1]], ['10 ml'], ['15 ml']]) || find([['50 ml']]);
      return find([['50 ml', conc[0]], ['50 ml', conc[1]], ['50 ml'], ['8 oz room'], ['4 oz room']]) || vs[vs.length - 1];
    }
    var big = ((ans.proj || [])[0] === 'full') || ((ans.room || [])[0] === 'living' && (ans.proj || [])[0] !== 'quiet');
    if (fmt === 'melts') return find([['luxe wax melts'], ['wax melt bar'], ['gift box (8)'], ['gift box (6)'], ['melt']]) || find([['8 oz', 'candle']]);
    if (fmt === 'spray') return find([['room + pillow'], ['8 oz room'], ['room perfume'], ['4 oz room'], ['spray']]) || find([['8 oz', 'candle']]);
    if (fmt === 'car') return find([['car diffuser']]) || find([['8 oz', 'candle']]);
    return (big ? find([['16 oz', 'candle']]) : null) || find([['8 oz', 'candle'], ['16 oz', 'candle']]) || vs[0];
  }
  function matchesFormat(p, path, ans) {
    var fmt = (ans.fmt || [])[0], titles = (p.v || []).filter(function (v) { return v[3]; }).map(function (v) { return v[1].toLowerCase(); }).join(' | ');
    if (path === 'wear') {
      if (fmt === 'body') return /body butter|lotion|wash/.test(titles);
      if (fmt === 'vial') return /2 ?ml|vial/.test(titles);
      if (fmt === 'travel') return /15 ml|10 ml/.test(titles);
      return /50 ml/.test(titles);
    }
    if (fmt === 'melts') return /melt/.test(titles);
    if (fmt === 'spray') return /room \+ pillow|room perfume|spray/.test(titles);
    if (fmt === 'car') return /car diffuser/.test(titles);
    return /candle/.test(titles);
  }
  function variantLabel(t) { return t.replace(/\s*–\s*Coconut Wax, Wood Wick/i, ' · wood wick').replace(/\s*\|\s*\d+ mL/i, ''); }

  function whyCopy(prod, path, ans, uv) {
    var pr = prod._p, q = PATHS[path].questions, parts = [];
    function phr(id) { var k = (ans[id] || [])[0]; var qq = q.filter(function (x) { return x.id === id; })[0]; var o = qq && qq.opts.filter(function (x) { return x.k === k; })[0]; return o && o.phrase; }
    var top = FAMS.slice().sort(function (a, b) { return (pr.f[b] * (uv.u[b] + .2)) - (pr.f[a] * (uv.u[a] + .2)); }).filter(function (k) { return pr.f[k] > 0; }).slice(0, 2);
    var fam = top.map(function (k) { return FAM_PHRASE[k]; }).join(', softened by ');
    if (path === 'wear') {
      var lead = 'You asked for ' + (phr('mood') || 'a fragrance of your own') + ', ' + (phr('proj') || 'worn your way') + ' ' + (phr('when') || '') + '.';
      parts.push(lead.replace(/\s+\./, '.'));
    } else {
      parts.push('A scent for ' + (phr('room') || 'your home') + ' ' + (phr('when') || '') + ', ' + (phr('proj') || 'present but never overwhelming') + '.');
    }
    parts.push(prod.name + ' answers with ' + (prod.notes ? softCase(prod.notes).replace(/ · /g, ', ') : 'its own accord') + (fam ? ': ' + fam + '.' : '.'));
    if (uv.meta.insp) { var tie = inspired(prod, uv.meta.insp);
      if (tie === 2) parts.push('It was poured for exactly the line you chose: \u201c' + uv.meta.insp.quote + '\u201d');
      else if (tie === 1) parts.push('It carries the same air as the line you chose.'); }
    return parts.join(' ').replace(/\s+,/g, ',').replace(/ {2,}/g, ' ');
  }

  /* ---------------- App ---------------- */
  function init(root) {
    var dataEl = $('[data-ff-catalog]', root), cfgEl = $('[data-ff-config]', root);
    var catalog = []; try { catalog = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var cfg = {}; try { cfg = JSON.parse(cfgEl ? cfgEl.textContent : '{}'); } catch (e) {}
    var exclude = (cfg.exclude || []), boost = (cfg.boost || []);
    var seen = {};
    catalog = catalog.filter(function (p) {
      if (seen[p.h] || exclude.indexOf(p.h) > -1) return false; seen[p.h] = 1;
      var t = (p.n + ' ' + p.ty).toLowerCase();
      if (/mystery|discovery set|journal|t-shirt|book|tee\b/.test(t)) return false;
      return (p.v || []).some(function (v) { return v[3]; }) && p.i;
    });
    catalog.forEach(function (p) {
      p.name = cleanName(p.n); p.notes = cleanNotes(p.notes); p._p = profile(p); p.boost = boost.indexOf(p.h) > -1;
      var ty = (p.ty || '').toLowerCase();
      p.path = ty.indexOf('perfume') === 0 ? 'wear' : (/candle|wax|room/.test(ty) ? 'home' : null);
    });

    var state = { path: null, step: 0, ans: {} };
    var stage = $('[data-ff-stage]', root);
    var KEY = 'gncc-ff-v1';
    function save() { try { sessionStorage.setItem(KEY, JSON.stringify(state)); } catch (e) {} }
    function load() { try { var s = JSON.parse(sessionStorage.getItem(KEY) || 'null'); if (s && s.path) state = s; } catch (e) {} }

    function go(fn) {
      stage.classList.add('is-leaving');
      setTimeout(function () {
        fn(); stage.classList.remove('is-leaving');
        var top = root.getBoundingClientRect().top + window.pageYOffset - 90;
        if (Math.abs(window.pageYOffset - top) > 160) window.scrollTo({ top: top, behavior: 'smooth' });
        var h = $('h2, h3', stage); if (h) { h.setAttribute('tabindex', '-1'); h.focus({ preventScroll: true }); }
      }, 220);
    }

    function renderIntro() {
      root.setAttribute('data-ff-view', 'intro');
      stage.innerHTML = $('[data-ff-intro-tpl]', root).innerHTML;
      $$('[data-ff-path]', stage).forEach(function (b) {
        b.addEventListener('click', function () { var p = b.getAttribute('data-ff-path'); go(function () { state = { path: p, step: 0, ans: {} }; save(); renderQ(); }); });
      });
    }

    function renderQ() {
      root.setAttribute('data-ff-view', 'q');
      var qs = PATHS[state.path].questions, q = qs[state.step], picked = state.ans[q.id] || [];
      var opts = q.opts.filter(function (o) { return !o.only || o.only === state.path; });
      var title = (state.path === 'home' && q.qHome) ? q.qHome : q.q;
      var html = '<div class="ff-q">' +
        '<div class="ff-q__meta"><span class="ff-kick">' + esc(PATHS[state.path].label) + '</span><span class="ff-step">' + roman(state.step + 1) + ' <i>/</i> ' + roman(qs.length) + '</span></div>' +
        '<div class="ff-progress" aria-hidden="true"><i style="width:' + ((state.step + 1) / qs.length * 100) + '%"></i></div>' +
        '<h2 class="ff-h ff-h--q">' + esc(title) + '</h2>' + (q.sub ? '<p class="ff-sub">' + esc(q.sub) + '</p>' : '') +
        '<div class="ff-opts' + (q.wide ? ' ff-opts--places' : (opts.length > 5 ? ' ff-opts--many' : '')) + '" role="group" aria-label="' + esc(title) + '">' +
        opts.filter(function (o) { return !o.skip; }).map(function (o, i) {
          var on = picked.indexOf(o.k) > -1;
          return '<button type="button" class="ff-opt" data-k="' + o.k + '" aria-pressed="' + on + '"><span class="ff-opt__n">' + String(i + 1).padStart(2, '0') + '</span>' + (o.quote ? '<span class="ff-opt__t ff-opt__t--quote">&ldquo;' + esc(o.quote) + '&rdquo;</span>' : '<span class="ff-opt__t">' + esc(o.t) + '</span>') + '<span class="ff-opt__d">' + esc(o.d) + '</span>' + '<span class="ff-opt__mark" aria-hidden="true"></span></button>';
        }).join('') + '</div>' +
        '<div class="ff-nav"><button type="button" class="ff-link" data-ff-back>&larr; ' + (state.step ? 'Back' : 'Start over') + '</button>' +
        opts.filter(function (o) { return o.skip; }).map(function (o) { return '<button type="button" class="ff-link ff-skip" data-k="' + o.k + '" aria-pressed="' + (picked.indexOf(o.k) > -1) + '">' + 'None of these &middot; let the notes lead <span aria-hidden="true">&rarr;</span></button>'; }).join('') +
        ((q.multi || q.optional) ? '<button type="button" class="ff-btn" data-ff-next' + ((!q.optional && !picked.length) ? ' disabled' : '') + '>' + (q.optional && !picked.length ? 'I am open to everything' : 'Continue') + ' <span aria-hidden="true">&rarr;</span></button>' : '') +
        '</div></div>';
      stage.innerHTML = html;
      $$('.ff-opt, .ff-skip', stage).forEach(function (b) {
        b.addEventListener('click', function () {
          var k = b.getAttribute('data-k'), cur = (state.ans[q.id] || []).slice();
          if (q.multi) {
            var ix = cur.indexOf(k);
            if (ix > -1) cur.splice(ix, 1); else { if (cur.length >= q.multi) cur.shift(); cur.push(k); }
            state.ans[q.id] = cur; save();
            $$('.ff-opt', stage).forEach(function (x) { x.setAttribute('aria-pressed', cur.indexOf(x.getAttribute('data-k')) > -1); });
            var nx = $('[data-ff-next]', stage);
            if (nx) { nx.disabled = !q.optional && !cur.length; nx.innerHTML = (q.optional && !cur.length ? 'I am open to everything' : 'Continue') + ' <span aria-hidden="true">&rarr;</span>'; }
          } else {
            state.ans[q.id] = [k]; save();
            $$('.ff-opt', stage).forEach(function (x) { x.setAttribute('aria-pressed', x === b); });
            setTimeout(next, 260);
          }
        });
      });
      var nb = $('[data-ff-next]', stage); if (nb) nb.addEventListener('click', next);
      $('[data-ff-back]', stage).addEventListener('click', function () {
        go(function () { if (state.step) { state.step--; save(); renderQ(); } else { state = { path: null, step: 0, ans: {} }; save(); renderIntro(); } });
      });
    }
    function next() {
      var qs = PATHS[state.path].questions;
      go(function () { if (state.step < qs.length - 1) { state.step++; save(); renderQ(); } else { state.step = qs.length; save(); renderResults(); } });
    }

    function card(p, v, small) {
      return '<article class="ff-card' + (small ? ' ff-card--s' : '') + '">' +
        '<a class="ff-card__img" href="' + esc(p.u) + '"><img src="' + esc(p.i) + '" alt="' + esc(p.name) + '" loading="lazy" width="600" height="600"></a>' +
        '<h4 class="ff-card__t"><a href="' + esc(p.u) + '">' + esc(p.name) + '</a></h4>' +
        '<p class="ff-card__n">' + esc(p.notes) + '</p>' +
        (v ? '<div class="ff-card__f"><span><small>' + esc(variantLabel(v[1])) + '</small><b>' + money(v[2]) + '</b></span>' +
          '<button type="button" class="ff-add ff-add--s" data-ff-add="' + v[0] + '" data-ff-name="' + esc(p.name) + '">Add to bag</button></div>' : '') +
        '</article>';
    }

    function renderResults() {
      root.setAttribute('data-ff-view', 'r');
      var path = state.path, ans = state.ans, uv = userVector(path, ans);
      var pool = catalog.filter(function (p) { return p.path === path; });
      var withFmt = pool.filter(function (p) { return matchesFormat(p, path, ans); });
      if (withFmt.length >= 4) pool = withFmt;
      pool.forEach(function (p) { p._s = score(p, uv); });
      pool.sort(function (a, b) { return b._s - a._s; });
      var picks = [], names = {};
      pool.forEach(function (p) { var b = baseName(p); if (!names[b] && picks.length < 4) { names[b] = 1; picks.push(p); } });
      if (!picks.length) { stage.innerHTML = '<p class="ff-sub">We could not find a match just now. <a href="' + esc(cfg.fallback || '/collections/all') + '">Browse the full collection</a>.</p>'; return; }
      var sig = picks[0], alts = picks.slice(1, 4), sv = pickVariant(sig, path, ans);
      var other = catalog.filter(function (p) { return p.path && p.path !== path && baseName(p) === baseName(sig); })[0];
      var ov = other ? pickVariant(other, other.path, {}) : null;
      var allV = (sig.v || []).filter(function (v) { return v[3]; });
      var topF = FAMS.slice().sort(function (a, b) { return sig._p.f[b] - sig._p.f[a]; }).filter(function (k) { return sig._p.f[k] > .2; }).slice(0, 4);
      var vial = path === 'wear' && (ans.fmt || [])[0] !== 'vial' ? (sig.v || []).filter(function (v) { return v[3] && /2 ?ml|vial/i.test(v[1]); })[0] : null;
      var concNote = path === 'wear' && sv ? (/extrait/i.test(sv[1]) ? 'Extrait de Parfum: our richest concentration, deeper on skin and longest-wearing.' : (/toilette/i.test(sv[1]) ? 'Eau de Toilette: a lighter, airier concentration that stays close.' : '')) : '';

      var html = '<div class="ff-r">' +
        '<div class="ff-r__head"><span class="ff-kick">Your consultation &middot; ' + esc(PATHS[path].label) + '</span>' +
        '<h2 class="ff-h ff-h--r">' + esc(cfg.result_heading || 'We would pour this for you.') + '</h2></div>' +
        '<div class="ff-record">' +
          '<a class="ff-record__img" href="' + esc(sig.u) + '"><img src="' + esc(sig.i.replace(/width=\d+/, 'width=1100')) + '" alt="' + esc(sig.name) + '" width="900" height="900"></a>' +
          '<div class="ff-record__body">' +
            '<p class="ff-record__label">No. 1 &middot; Your signature</p>' +
            '<h3 class="ff-h ff-record__name">' + esc(sig.name) + '</h3>' +
            '<p class="ff-record__notes">' + esc(sig.notes) + '</p>' +
            '<div class="ff-rule" aria-hidden="true"></div>' +
            '<p class="ff-record__why"><span>Why it suits you</span>' + esc(whyCopy(sig, path, ans, uv)) + '</p>' +
            (topF.length ? '<ul class="ff-facets">' + topF.map(function (k) { return '<li><span>' + FAM_LABEL[k] + '</span><i style="--w:' + Math.round(sig._p.f[k] * 100) + '%"></i></li>'; }).join('') + '</ul>' : '') +
            (sv ? '<div class="ff-buy">' +
              '<label class="ff-buy__label" for="ffv-' + root.id + '">Size &amp; format</label>' +
              '<div class="ff-select"><select id="ffv-' + root.id + '" data-ff-variant>' + allV.map(function (v) { return '<option value="' + v[0] + '" data-p="' + v[2] + '"' + (v[0] === sv[0] ? ' selected' : '') + '>' + esc(variantLabel(v[1])) + '</option>'; }).join('') + '</select></div>' +
              (concNote ? '<p class="ff-buy__note">' + esc(concNote) + '</p>' : '') +
              '<div class="ff-buy__row"><button type="button" class="ff-btn ff-btn--solid ff-add" data-ff-add="' + sv[0] + '" data-ff-name="' + esc(sig.name) + '">Add to bag &middot; <span data-ff-price>' + money(sv[2]) + '</span></button>' +
              '<a class="ff-link" href="' + esc(sig.u) + '">Read the full story &rarr;</a></div>' +
              (vial ? '<p class="ff-buy__vial">Prefer to try it on skin first? <button type="button" class="ff-inline" data-ff-add="' + vial[0] + '" data-ff-name="' + esc(sig.name) + ' discovery vial">Add the 2 ml discovery vial &middot; ' + money(vial[2]) + '</button></p>' : '') +
            '</div>' : '') +
          '</div>' +
        '</div>' +
        (alts.length ? '<div class="ff-alts"><div class="ff-alts__head"><span class="ff-kick">Also in your profile</span><p>Close relatives, each with a different emphasis.</p></div><div class="ff-grid">' +
          alts.map(function (p) { return card(p, pickVariant(p, path, ans)); }).join('') + '</div></div>' : '') +
        (other && ov ? '<div class="ff-pair"><div class="ff-pair__txt"><span class="ff-kick">' + (path === 'wear' ? 'Carry it home' : 'Wear it too') + '</span>' +
          '<h3 class="ff-h ff-h--m">' + esc(sig.name) + ' is also poured as ' + (path === 'wear' ? 'a candle for your rooms.' : 'a perfume for your skin.') + '</h3>' +
          '<p>The same accord, translated for ' + (path === 'wear' ? 'the home' : 'the body') + '. Many of our clients keep both.</p></div>' + card(other, ov, true) + '</div>' : '') +
        '<div class="ff-again"><button type="button" class="ff-link" data-ff-restart>&larr; Begin a new consultation</button>' +
        '<button type="button" class="ff-link" data-ff-switch>Try ' + (path === 'wear' ? 'For the Home' : 'To Wear') + ' &rarr;</button></div>' +
        '</div>';
      stage.innerHTML = html;

      var sel = $('[data-ff-variant]', stage), mainAdd = $('.ff-buy .ff-add', stage);
      if (sel) sel.addEventListener('change', function () { var o = sel.options[sel.selectedIndex]; mainAdd.setAttribute('data-ff-add', o.value); $('[data-ff-price]', stage).textContent = money(+o.getAttribute('data-p')); });
      $$('[data-ff-add]', stage).forEach(function (b) { b.addEventListener('click', function () { addToBag(b); }); });
      $('[data-ff-restart]', stage).addEventListener('click', function () { go(function () { state = { path: null, step: 0, ans: {} }; save(); renderIntro(); }); });
      $('[data-ff-switch]', stage).addEventListener('click', function () { go(function () { state = { path: path === 'wear' ? 'home' : 'wear', step: 0, ans: {} }; save(); renderQ(); }); });
      try { if (window.Shopify && window.Shopify.analytics && window.Shopify.analytics.publish) window.Shopify.analytics.publish('gncc_finder_result', { path: path, product: sig.h }); } catch (e) {}
    }

    function toast(msg) {
      var t = $('[data-ff-toast]', root);
      t.innerHTML = msg; t.classList.add('on'); clearTimeout(t._h); t._h = setTimeout(function () { t.classList.remove('on'); }, 5200);
    }
    function addToBag(btn) {
      var id = +btn.getAttribute('data-ff-add'), name = btn.getAttribute('data-ff-name');
      var label = btn.innerHTML; btn.disabled = true; btn.classList.add('is-busy');
      var done = function (ok) {
        btn.disabled = false; btn.classList.remove('is-busy');
        if (ok) { btn.innerHTML = 'Added'; setTimeout(function () { btn.innerHTML = label; }, 2200); toast('<b>' + esc(name) + '</b> is in your bag. <a href="' + (cfg.cart_url || '/cart') + '">View bag &rarr;</a>'); }
        else toast('That size just sold out. <a href="' + (cfg.cart_url || '/cart') + '">View bag</a>');
      };
      if (window.FF_PREVIEW) { setTimeout(function () { done(true); }, 400); return; }
      fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: id, quantity: 1, properties: { _source: 'Fragrance Finder' } }] })
      }).then(function (r) { return r.ok ? r.json() : Promise.reject(r); }).then(function () {
        done(true);
        return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
          $$('[data-cart-count], .cart-count-bubble span:first-child, .cart-count, .header__cart-count').forEach(function (el) { el.textContent = c.item_count; });
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true })); document.dispatchEvent(new CustomEvent('cart:updated', { detail: c, bubbles: true }));
        });
      }).catch(function () { done(false); });
    }

    load();
    if (state.path && state.step >= PATHS[state.path].questions.length) renderResults();
    else if (state.path) renderQ(); else renderIntro();
    root.classList.add('is-ready');
  }

  function boot() { $$('[data-ff]').forEach(function (r) { if (!r._ff) { r._ff = 1; init(r); } }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
